import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateEnvelop } from '../../redux/envelop/envelop_actions';

const mapStateToProps = state => ({
  isDuplicating: state.envelop.isDuplicating,
  errorMessage: state.envelop.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  duplicate: (id, name) => dispatch(duplicateEnvelop(id, name, props.item.type)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/EnvelopDuplicateModal.js